var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlayOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "play_circle_outline-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M0,0H29V29H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M11.667,19.521l7.25-5.438-7.25-5.437ZM14.083,2A12.083,12.083,0,1,0,26.167,14.083,12.088,12.088,0,0,0,14.083,2Zm0,21.75a9.667,9.667,0,1,1,9.667-9.667A9.68,9.68,0,0,1,14.083,23.75Z",
    transform: "translate(0.417 0.417)",
    fill: "#3aa100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayOutline);
export default __webpack_public_path__ + "static/media/icon_play_outline.927aa040c58fcd27e52945dfe29d4559.svg";
export { ForwardRef as ReactComponent };